const initTestimonialCarousel = async () => {
    const holder = document.querySelectorAll<HTMLElement>('.wp-block-group.is-style-carousel');
    if (!holder.length) return;

    const { default: Swiper } = await import("swiper");
    const { Navigation, Pagination } = await import("swiper/modules");

    const initHolderAsCarousel = (holder: HTMLElement) => {
        if (holder.classList.contains('swiper-wrapper')) return;

        const wrapper = document.createElement('div')
        wrapper.classList.add('swiper')

        holder.insertAdjacentElement('beforebegin', wrapper)
        wrapper.appendChild(holder)

        holder.classList.add('swiper-wrapper')
        holder.classList.remove('wp-block-group', 'is-layout-flex')

        const navHolder = document.createElement('nav')
        navHolder.classList.add('flex', 'gap-2', 'items-center', 'justify-center', '*:shadow-subtle', '!-mt-4')

        const prevBtn = document.createElement('button')
        prevBtn.classList.add('bg-white', 'text-dark/30', 'border', 'border-dark/10', 'rounded-full', 'w-10', 'h-10', 'flex', 'items-center', 'justify-center', 'hover:bg-gray', 'transition-colors', '*:rotate-180')
        prevBtn.insertAdjacentHTML('afterbegin', '<svg fill="currentColor" class="w-6 h-6" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M16.175 13H4V11H16.175L10.575 5.4L12 4L20 12L12 20L10.575 18.6L16.175 13Z"></path></svg>')

        const nextBtn = prevBtn.cloneNode(true) as HTMLElement

        prevBtn.setAttribute('aria-label', 'Předchozí')
        navHolder.appendChild(prevBtn)

        const paginationEl = document.createElement('div')
        paginationEl.classList.add('bg-white', 'border', 'border-dark/10', 'rounded-[30px]', 'px-4', 'py-4', 'space-x-1', 'leading-0')
        navHolder.appendChild(paginationEl)

        nextBtn.classList.remove('*:rotate-180')
        nextBtn.setAttribute('aria-label', 'Další')
        navHolder.appendChild(nextBtn)

        wrapper.insertAdjacentElement('afterend', navHolder)

        new Swiper(wrapper, {
            modules: [Navigation, Pagination],
            slidesPerView: 'auto',
            slideClass: 'wp-block-quote',
            spaceBetween: 16,
            centeredSlides: holder.children.length > 2,
            centerInsufficientSlides: true,
            watchSlidesProgress: true,
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
            },
            pagination: {
                el: paginationEl,
                clickable: true,
                bulletClass: 'inline-block w-2 h-2 rounded-full bg-dark/30 transition-all cursor-pointer',
                bulletActiveClass: '!w-5 !bg-product',
            },
            breakpoints: {
                640: {
                    spaceBetween: 24,
                },
                1024: {
                    spaceBetween: 32,
                },
            }
        })
    }

    holder.forEach(holder => initHolderAsCarousel(holder))
}

export default initTestimonialCarousel